// client/src/components/agent/ListContactsView.jsx
import { useState, useEffect } from 'react';
import { theme } from '../../theme';
import { useIsMobile } from '../../hooks/useMediaQuery';

// MariaDB devuelve la columna JSON `custom` como string; MySQL ya la parsea.
function parseCustom(custom) {
  if (!custom) return {};
  if (typeof custom === 'object') return custom;
  try { return JSON.parse(custom) || {}; } catch { return {}; }
}

export default function ListContactsView({ token, customFields }) {
  const [lists, setLists] = useState([]);
  const [selected, setSelected] = useState(null);
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const isMobile = useIsMobile();
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    fetch('/api/agent/list-contacts', { headers }).then((r) => r.json()).then(setLists).catch(() => {});
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  const viewList = async (list) => {
    setSelected(list);
    setLoading(true);
    try {
      const data = await fetch(`/api/agent/list-contacts/${list.id}/contacts`, { headers }).then((r) => r.json());
      setContacts(data);
    } catch { setContacts([]); }
    setLoading(false);
  };

  return (
    <div style={{ flex: 1, padding: isMobile ? '1rem' : '1.5rem', overflowY: 'auto', minWidth: 0 }}>
      {!selected ? (
        <>
          <h2 style={{ color: theme.colors.primary, fontSize: '1.1rem', marginBottom: '1.2rem' }}>
            Listas de contactos
          </h2>
          {lists.length === 0 && (
            <p style={{ color: theme.colors.textMuted }}>Sin listas creadas.</p>
          )}
          {lists.map((l) => (
            <div key={l.id} style={{
              background: theme.colors.surface, border: `1px solid ${theme.colors.border}`,
              borderRadius: '10px', padding: '1rem 1.2rem', marginBottom: '10px',
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            }}>
              <div>
                <div style={{ color: theme.colors.text, fontWeight: 600 }}>{l.name}</div>
                {l.description && <div style={{ color: theme.colors.textMuted, fontSize: '0.82rem', marginTop: '2px' }}>{l.description}</div>}
              </div>
              <button onClick={() => viewList(l)} style={{
                background: theme.colors.primary, border: 'none', borderRadius: '6px',
                padding: '7px 16px', cursor: 'pointer', color: '#0f0f0f', fontWeight: 700, fontSize: '0.85rem',
              }}>
                Ver
              </button>
            </div>
          ))}
        </>
      ) : (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '1.2rem' }}>
            <button onClick={() => { setSelected(null); setContacts([]); }} style={{
              background: 'transparent', border: `1px solid ${theme.colors.border}`,
              borderRadius: '6px', padding: '5px 12px', cursor: 'pointer', color: theme.colors.textMuted,
            }}>
              ← Volver
            </button>
            <h2 style={{ color: theme.colors.primary, fontSize: '1.1rem', margin: 0 }}>{selected.name}</h2>
          </div>
          {loading ? (
            <p style={{ color: theme.colors.textMuted }}>Cargando...</p>
          ) : contacts.length === 0 ? (
            <p style={{ color: theme.colors.textMuted }}>Sin contactos en esta lista.</p>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85rem' }}>
                <thead>
                  <tr style={{ borderBottom: `1px solid ${theme.colors.border}` }}>
                    <th style={{ textAlign: 'left', padding: '8px 12px', color: theme.colors.textMuted }}>Número</th>
                    {customFields.map((f) => (
                      <th key={f.id} style={{ textAlign: 'left', padding: '8px 12px', color: theme.colors.textMuted }}>{f.name}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {contacts.map((c) => {
                    const custom = parseCustom(c.custom);
                    return (
                    <tr key={c.id} style={{ borderBottom: `1px solid ${theme.colors.border}` }}>
                      <td style={{ padding: '8px 12px', color: theme.colors.text }}>{c.id}</td>
                      {customFields.map((f) => (
                        <td key={f.id} style={{ padding: '8px 12px', color: theme.colors.textMuted }}>
                          {custom[f.name] || '—'}
                        </td>
                      ))}
                    </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
}
